export var getToasts = function (state) { return state.toasts.list; };
export var getAutoDeleteTime = function (state) { return state.toasts.autoDeleteTime; };
